import {Component} from "@angular/core";
import {FormBuilder} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {RouteParamsService} from "../../../../global-services/route-params.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ClipboardService} from "ngx-clipboard";
import {SweetAlertService} from "../../../../global-services/sweet-alert.service";
import {EnumDataWarehousePageRoute, EnumMainPageRoute} from "../../../../enums/router.enum";
import {DataField} from "../_models/data-schema.model";

@Component({
  selector: 'app-api-fetching',
  styleUrls: ['./api-fetching.component.scss'],
  templateUrl: './api-fetching.component.html'
})
export class ApiFetchingComponent {
  daeID: any;
  entityName: string;

  rsSchemaPkList: DataField[];
  localToken: string = localStorage.getItem("token");
  BASE_URL: string = `https://${window.location.hostname}/`;
  getByKeyUrl: string;
  getByBatchUrl: string;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private routeParamsService: RouteParamsService,
    private activatedRoute: ActivatedRoute,
    private clipboardApi: ClipboardService,
    private sweetAlertService: SweetAlertService,
    private router: Router,
  ) {
    this.activatedRoute.data.subscribe((data: {rsEntity: any, rsSchemaPkList: DataField[]}) => {
      this.entityName = data.rsEntity.name;
      this.daeID = data.rsEntity.id;
      this.getByKeyUrl = this.BASE_URL + `api/protected/simpleQuery/getByKey`;
      this.getByBatchUrl = this.BASE_URL + `api/protected/simpleQuery/getByBatch`;
      this.rsSchemaPkList = data.rsSchemaPkList;
    })
  }

  onNavigateToDataView() {
    this.router.navigate([`/${EnumMainPageRoute.DataWarehouse}/${EnumDataWarehousePageRoute.DataView}`, this.daeID]).then();
  }

  copyUrl(url) {
    this.sweetAlertService.autoCloseInfo("Copy text", "Success");
    this.clipboardApi.copyFromContent(url);
  }

  copyValue(value) {
    this.sweetAlertService.autoCloseInfo("Copy text", "Success");
    this.clipboardApi.copyFromContent(value);
  }

}
